import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    CurrentPersonDto,
    LoggedInUser,
    UserService,
    UserStatus,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import {
    SelectedOrganisation,
    WorkspaceStateService
} from '@flyfreely-portal-ui/workspace';
import {
    fadeInExpandOnEnterAnimation,
    fadeOutCollapseOnLeaveAnimation
} from 'angular-animations';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ManageDashboardWidgetsService } from './manage-dashboard-widgets.service';
import { WidgetRegistration } from '@flyfreely-portal-ui/widget';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    animations: [
        fadeInExpandOnEnterAnimation(),
        fadeOutCollapseOnLeaveAnimation()
    ],
    styleUrls: [`./dashboard.component.scss`]
})
export class DashboardComponent implements OnInit, OnDestroy {
    isSystemAdmin = false;
    showDynamicHelpEdit = false;

    currentUser?: CurrentPersonDto;
    currentOrganisation: SelectedOrganisation = { type: 'loading' };

    working = false;
    private workTracker = new WorkTracker();

    private ngUnsubscribe$ = new Subject<void>();

    showingWidgets$: Observable<WidgetRegistration[]>;

    constructor(
        private userService: UserService,
        private sharedService: WorkspaceStateService,
        private manageDashboardWidgetsService: ManageDashboardWidgetsService
    ) {
        this.showingWidgets$ =
            this.manageDashboardWidgetsService.availableWidgets$.pipe(
                takeUntil(this.ngUnsubscribe$),
                map(widgets =>
                    this.manageDashboardWidgetsService.registeredWidgets.registeredWidgets.filter(
                        w =>
                            widgets[w.widgetIdentifier].available &&
                            widgets[w.widgetIdentifier].selected
                    )
                )
            );
        this.workTracker.observable
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(working => (this.working = working));
    }

    ngOnInit() {
        combineLatest([
            this.userService.userChange$.pipe(
                filter<LoggedInUser>(c => c.type === UserStatus.LOGGED_IN)
            ),
            this.sharedService.currentOrganisation$
        ])
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(([changes, organisation]) => {
                this.currentUser = changes.currentUser;
                this.currentOrganisation = organisation;
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    logout() {
        this.userService.logout();
    }
}
